// extracted by mini-css-extract-plugin
export var blink = "_8b-2";
export var cursor = "_8b-1";
export var reactMarkdown = "_8b-3";
export var streamingText = "_8b-0";